export default import.meta.ROLLDOWN_FILE_URL_O6UGBYXK57I7akFyyO$NyQ